<template>
    <div class="user-create layout-small-form">
        <b-row class="justify-content-md-center">
            <b-col cols="12" md="6" md-offset="3">
                <div v-if="state === CONFIRMED">
                    <heading :title="title" tag="user-create-confirmed-title"/>
                    <p>Your e-mail has been confirmed!</p>
                </div>
                <div v-else-if="state === CONFIRM_ERROR">
                    <heading :title="title" tag="user-create-error-title"/>
                    <p>This user activation link is invalid or has already been used. If you setup a username and password please login to continue account setup.</p>
                </div>
                <div v-else-if="state === SUBMITTED">
                    <heading :title="title" tag="user-create-email-title"/>
                    <p>Account created! Check your e-mail for an activation link.</p>
                </div>
                <div v-else>
                    <div v-if="state === SUBMIT_ERROR">
                        <b-alert show variant="danger">
                            A user with this e-mail already exists!
                        </b-alert>
                    </div>
                    <data-form :title="title"
                               tag="user-create"
                               save-button-label="Create Account"
                               :field-model="userFields"
                               :field-groups="userInfoGroups"
                               :load-model-instance="loadUserModel"
                               :hidden="state !== USER_INFO"
                               :on-submit-handler="onSubmitUserInfo"/>

                    <data-form save-button-label="Activate"
                               :field-model="userFields"
                               :field-groups="userPasswordGroups"
                               :hidden="state !== USER_PASSWORD"
                               :on-submit-handler="onSubmitUserPassword"/>
                </div>

            </b-col>
        </b-row>
    </div>

</template>

<script>

import Vue from 'vue'
import UserFields from '@/models/User'

/**
 * Page for a new Participant to create their account
 */
export default Vue.extend({
    name: 'UserCreate',
    props: {
        activate_key: String,
        email: String,
        role: String, //Given for projman, or progadmin invite, but not EO create
    },
    data () {
        return {
            userFields: UserFields,
            userPasswordGroups: [
                ['password', 'phone_office', 'phone_mobile'],
            ],
            USER_INFO: 1,
            SUBMITTED: 2,
            SUBMIT_ERROR: 3,
            USER_PASSWORD: 4,
            CONFIRMED: 5,
            CONFIRM_ERROR: 6,
            state: 1
        }
    },
    computed: {
        userInfoGroups() {
            if(this.activate_key) {
                return [['first_name', 'last_name', 'activate_key']]
            } else {
               return [['email', 'first_name', 'last_name', 'activate_key']]
            }
        },
        accountTypeText () {
            if (!this.role) {
                return 'Equipment Owner'
            } else if (this.role === 'PROGRAM_ADMIN') {
                return 'Program Admin'
            } else if (this.role === 'PROJECT_MANAGER') {
                return 'Project Manager'
            } else if (this.role === 'OWNERS_REPRESENTATIVE') {
                return 'Owners Representative'
            } else if (this.role === 'AUDITOR') {
                return 'Auditor'
            }
            return ''
        },
        title () {
            return `Create ${this.accountTypeText} Account`
        }
    },
    methods: {
        onSubmitUserInfo (modelInstance) {
            return this.$api.createUser(this, modelInstance, this.activate_key)
                .then((response) => {
                        if (this.activate_key) {
                            this.state = this.USER_PASSWORD
                        } else {
                            this.state = this.SUBMITTED
                        }
                    },
                    (response) => {
                        this.state = this.SUBMIT_ERROR
                    })
        },
        onSubmitUserPassword (modelInstance) {
            modelInstance.activate_key = this.activate_key
            return this.$api.activate(this, modelInstance)
                .then((response) => {
                        if (this.$user.setUserFromLoginResponse(this, response)) {
                            this.state = this.CONFIRMED
                            this.$router.push('/')
                        } else {
                            this.state = this.CONFIRMED_ERROR
                        }
                    },
                    (response) => {
                        this.state = this.CONFIRM_ERROR
                    })
        },
        loadUserModel () {
            return new Promise((resolve, reject) => {
                const instance = this.email ? { email: this.email, activate_key: this.activate_key } : {}
                resolve(instance)
            })
        }
    },
    beforeMount () {
        if (this.activate_key) {
            if(!this.role) {
                this.state = this.USER_PASSWORD
            }

            this.$api.checkActivationKey(this, this.activate_key).then((response) => {
               let keyExists = response.body
                if(!keyExists) {
                    this.state = this.CONFIRM_ERROR
                }
            })
        }
    }
})

</script>

<style lang="scss">
.user-create {
    .heading__buttons {
        margin-top: 6px;
        text-align: center;
        width: 100%;
    }
}

</style>